import { useEffect, useState } from 'react';
// Custom Hook.
// -----------------------------------------------------------------------------
export const useToastItem = ({ duration, id, onRemove }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isVisible, setIsVisible] = useState(true);
    // Effects.
    // ---------------------------------------------------------------------------
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            onRemove(id);
        }, duration);
        return () => {
            clearTimeout(timer);
        };
    }, [duration, id, onRemove]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        isVisible
    };
};
//# sourceMappingURL=ToastItem.hook.js.map